import PrescriptionFillsStatsContainer from './prescription-fills-stats-container';

export default PrescriptionFillsStatsContainer;